import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/tailwind.css';
import './styles/index.css';
import { StripeProvider } from './contexts/StripeContext';

const root = ReactDOM?.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <StripeProvider>
        <App />
      </StripeProvider>
    </HelmetProvider>
  </React.StrictMode>
);
